import { useTranslation } from 'react-i18next';
import { Text, Flex, Link } from '@radix-ui/themes';

import { addSeats } from '../../data';
import { useNotification } from '../../../../shared/Notification/useNotification';

export const AddSeats = ({ availableSeats, totalSeats }) => {
  const { t } = useTranslation(['clients', 'shared']);
  const { showSuccess, showError } = useNotification();

  const pingMixpanel = () => {
    window.Airbo.Utils.ping('Click Add Seats', {
      tab: 'Clients',
      // eslint-disable-next-line no-undef
      organization_name: Airbo.Utils.currentOrg().name,
    });
  };

  const handleAddSeats = async () => {
    try {
      pingMixpanel();

      await addSeats();

      showSuccess({
        title: t('clients:footer.titleMessage'),
        content: t('clients:footer.bodyMessage'),
      });
    } catch {
      showError({
        title: t('clients:footer.titleError'),
        content: t('clients:footer.bodyError'),
      });
    }
  };

  return (
    <Flex align="center" gap="2">
      {totalSeats && (
        <Text size="2">
          {t('clients:footer.available', { availableSeats, totalSeats })}
        </Text>
      )}
      <Link size="2" onClick={handleAddSeats}>
        {t('clients:footer.addSeats')}
      </Link>
    </Flex>
  );
};
